// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__rdeM_","signatureBlock":"Footer_signatureBlock__8MKUs","signature":"Footer_signature__2rAUc"};